import { makeAutoObservable, runInAction } from 'mobx';
import {
	cnpBatchUploadURL,
	companyBatchUploadURL,
	onboardBatchUploadURL,
	mitigationBatchUploadURL,
	esProgramBatchUploadURL,
	emissionActivityBatchUploadURL,
	reductionDirectionBatchUploadURL,
} from './api/url';
import axios from 'axios';
import { handleFetch } from '../../utils/handleFetch';
import { showToast } from '../../utils/toast';

class BatchUploadStore {
	selectedFile = [];
	selectedModule = {};
	moduleList = [
		{ value: 'Company', key: 'company', endpoint: companyBatchUploadURL },
		{
			value: 'Onboarding Information',
			key: 'onboard',
			endpoint: onboardBatchUploadURL,
		},
		{
			value: 'GHG Emission Activities',
			key: 'emissionActivity',
			endpoint: emissionActivityBatchUploadURL,
		},
		{
			value: 'Energy And Asset Profile',
			key: 'cnp',
			endpoint: cnpBatchUploadURL,
		},
		{
			value: 'Energy And Asset Profile (Other Mitigation)',
			key: 'energy_asset_profile_mitigation',
			endpoint: mitigationBatchUploadURL,
		},
	];

	constructor() {
		makeAutoObservable(this);
	}

	setSelectedModule = (key) => (this.selectedModule = this.moduleList.find((module) => module.key === key) || {});
	setESModule = (key, value) =>
		(this.selectedModule = {
			key: key,
			value: value,
			endpoint: esProgramBatchUploadURL,
		});

	setSelectedFile = (files) => {
		this.selectedFile = files;
	};

	handleCloseAndClear = () => {
		this.selectedFile = [];
	};

	downloadTemplate = async (endpoint) => {
		const lng = localStorage.getItem('i18nextLng') || 'en';

		const response = await axios.get(endpoint + `?lng=${lng}`, {
			haeders: {
				Accept: '*/*',
				'Access-Control-Allow-Origin': '*',
			},
			responseType: 'blob',
			withCredentials: true,
		});
		const blob = new Blob([response.data], {
			type: response.headers['content-type'],
		});
		let filename = 'template.xlsx';

		const contentDisposition = response.headers.get('content-disposition');
		if (contentDisposition) {
			const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
			if (filenameMatch) {
				filename = filenameMatch[1];
			}
		}

		const url = window.URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();

		window.URL.revokeObjectURL(url);
		document.body.removeChild(a);
	};

	uploadBatch = async (endpoint) => {
		const formData = new FormData();
		formData.append('file', this.selectedFile[0]);
		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: endpoint,
					method: 'POST',
					body: formData,
					isFormData: true,
					onSuccess: () => {
						runInAction(() => {
							this.selectedFile = [];
						});
					},
				});
				if (!success) throw new Error('Failed to upload file');
				return success;
			})(),
			{
				loading: 'Uploading file...',
				success: 'File uploaded successfully!',
				error: 'Failed to upload file',
			},
		);
	};
}

export const batchUploadStore = new BatchUploadStore();
